export const VALIDATION_ERROR_TYPES: QuoteErrorType[] = ['AGE_OUT_OF_RANGE', 'STATE_NOT_SUPPORTED'];

const KNOWN_LIMITATION_ERROR_TYPES: QuoteErrorType[] = [
  'AGE_OUT_OF_RANGE',
  'STATE_NOT_SUPPORTED',
  'NO_DEMOGRAPHICS_MATCH',
  'NO_CARRIER_MATCH',
];

export function isKnownLimitationError(error: QuoteError | null): error is QuoteError {
  return error !== null && KNOWN_LIMITATION_ERROR_TYPES.includes(error.type);
}

export function isUnexpectedError(error: QuoteError | null): error is QuoteError {
  return error !== null && error.type === 'UNEXPECTED_ERROR';
}

/**
 * @param quote - A quote that could be either PolicyQuote or TraditionalLTCQuote
 * @returns True if the quote is a TraditionalLTCQuote
 *
 * @example
 * ```typescript
 * if (isTraditionalLTCQuote(quote)) {
 *   // TypeScript knows quote is TraditionalLTCQuote here
 *   const premium = quote.primaryModalPremium;
 * }
 * ```
 */
export function isTraditionalLTCQuote(
  quote: PolicyQuote | TraditionalLTCQuote,
): quote is TraditionalLTCQuote {
  return 'traditionalLTCQuoteId' in quote && 'primaryModalPremium' in quote;
}

/**
 * @param quote - A quote that could be either PolicyQuote or TraditionalLTCQuote
 * @returns True if the quote is a PolicyQuote (life insurance)
 *
 * @example
 * ```typescript
 * if (isLifeInsuranceQuote(quote)) {
 *   // TypeScript knows quote is PolicyQuote here
 *   const premium = quote.premiumAmount;
 * }
 * ```
 */
export function isLifeInsuranceQuote(
  quote: PolicyQuote | TraditionalLTCQuote,
): quote is PolicyQuote {
  return 'insuranceQuoteId' in quote && 'premiumAmount' in quote;
}

/**
 * @param quote - A quote that could be either PolicyQuote or TraditionalLTCQuote
 * @returns The appropriate quote ID for the quote type
 */
export function getQuoteId(quote: PolicyQuote | TraditionalLTCQuote): string {
  return isTraditionalLTCQuote(quote) ? quote.traditionalLTCQuoteId : quote.insuranceQuoteId;
}
